module.exports = __webpack_public_path__ + "media/icons/heart_path-4842daf5.svg";